import styled from 'styled-components';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import TraitsRecordCardType from '../../enums/TraitsRecordCardType';

const HeaderContainer = styled.div(({ theme }) => `
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: ${theme.typography.fontFamily};
`);

const ProcedureInformation = styled.div(({ theme }) => `
  display: flex;
  flex-direction: column;
  font-size: 12px;
  color: ${theme.palette.grey[900]};
    
  .procedure-name {
    font-weight: 500;
  }

  .protocol-number {
    font-weight: 400;
  }
`);

const RecordStatusChip = styled(Chip)(({ theme }) => `
  && {
    padding: 7px 10px;
    font-size: 14px;
    font-weight: 400;
    font-family: ${theme.typography.fontFamily};
    border-radius: 4px;

    & .MuiChip-label {
      padding: 0;
    }

      &.update {
          background-color: #E7F3EB;
          color: #0F6B2E;
          border: 1px solid #0F6B2E;
      }

      &.deleted {
          background-color: #F0F0F0;
          color: #333333;
          border: 1px solid #CCCCCC;
      }
  }
`);
interface TraitsRecordCardChipProps {
  traitsRecordCardType?: TraitsRecordCardType;
}

function TraitsRecordCardChip({ traitsRecordCardType } : TraitsRecordCardChipProps) {
  const { t } = useTranslation();
  switch (traitsRecordCardType) {
    case TraitsRecordCardType.UPDATE:
      return <RecordStatusChip className="update" data-testid="record-status" label={t('Traits.Record Status.Update')} />;
    case TraitsRecordCardType.DELETED:
      return <RecordStatusChip className="deleted" data-testid="record-status" label={t('Traits.Record Status.Deleted')} />;
    default:
      return null;
  }
}

interface TraitsRecordCardHeaderProps {
  protocolNumber?: string;
  procedureName?: string;
  traitsRecordCardType?: TraitsRecordCardType;
}

export default function TraitsRecordCardHeader({ protocolNumber, procedureName, traitsRecordCardType }: TraitsRecordCardHeaderProps) {
  return (
    <HeaderContainer>
      <TraitsRecordCardChip traitsRecordCardType={traitsRecordCardType} />
      <ProcedureInformation>
        <div className="procedure-name" data-testid="record-procedure-name">{procedureName}</div>
        <div className="protocol-number" data-testid="record-protocol-number">{protocolNumber}</div>
      </ProcedureInformation>
    </HeaderContainer>
  );
}
